import { FC } from 'react';

type Props = {
	className?: string;
};

const User_02_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M15.4154 16.6665V14.9752C15.4154 13.9399 14.9493 12.9248 14.0073 12.4953C12.8583 11.9716 11.4803 11.6665 9.9987 11.6665C8.51711 11.6665 7.13911 11.9716 5.9901 12.4953C5.04809 12.9248 4.58203 13.9399 4.58203 14.9752V16.6665'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.9987 9.16634C11.6095 9.16634 12.9154 7.86051 12.9154 6.24967C12.9154 4.63884 11.6095 3.33301 9.9987 3.33301C8.38787 3.33301 7.08203 4.63884 7.08203 6.24967C7.08203 7.86051 8.38787 9.16634 9.9987 9.16634Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default User_02_Icon;
